export const WORKORDER_MANAGEMENT = 'dashboard';
export const WORKORDER = 'workOrder';
export const CUSTOMER_MASTER = 'customerMaster';
export const COMPANY_SETUP = 'companySetup';
export const USER_ROLES = 'userRoles';